import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { sitekeyRecaptcha } from "../../../config/config";

export default function Recaptcha(props) {
  const { onChangeRecaptcha, recaptchaRef } = props;

  return <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={sitekeyRecaptcha} onChange={onChangeRecaptcha} style={{zIndex: '3' , position:"absolute", marginBottom:"50px"}} 
  />;
}
